import { render, staticRenderFns } from "./ReadSignAgree.vue?vue&type=template&id=605c5c75"
import script from "./ReadSignAgree.vue?vue&type=script&lang=js"
export * from "./ReadSignAgree.vue?vue&type=script&lang=js"
import style0 from "./ReadSignAgree.vue?vue&type=style&index=0&id=605c5c75&prod&lang=less&Scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports